var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2227 32C25.0592 32 32.2227 24.8366 32.2227 16C32.2227 7.16344 25.0592 0 16.2227 0C7.3861 0 0.222656 7.16344 0.222656 16C0.222656 24.8366 7.3861 32 16.2227 32Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88141 15.8613L17.656 11.422C18.7196 10.9596 22.3265 9.47982 22.3265 9.47982C22.3265 9.47982 23.9912 8.83242 23.8525 10.4047C23.8063 11.0521 23.4363 13.318 23.0664 15.7688L21.9103 23.029C21.9103 23.029 21.8178 24.0925 21.0317 24.2775C20.2456 24.4625 18.9508 23.6301 18.7196 23.4451C18.5346 23.3064 15.2513 21.2255 14.049 20.2081C13.7253 19.9307 13.3554 19.3758 14.0953 18.7284C15.76 17.2024 17.7485 15.3064 18.9508 14.1041C19.5057 13.5492 20.0606 12.2544 17.7485 13.8266L11.2282 18.2197C11.2282 18.2197 10.4883 18.6821 9.10106 18.2659C7.71378 17.8498 6.09528 17.2948 6.09528 17.2948C6.09528 17.2948 4.98545 16.6012 6.88141 15.8613Z",
    fill: "#318392"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.2278dbe973d86f1f9f28f343e21afc30.svg";
export { ForwardRef as ReactComponent };